// extracted by mini-css-extract-plugin
export default {"container":"calculationsPopup_container__jTbBE","table":"calculationsPopup_table__46IVf"};